module.exports = __webpack_public_path__ + "img/ic_phone.f5bc2608.svg";